import React from "react";

export function SectionHeading({ eyebrow, title, action, id }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-7 border-b pb-4" style={{ borderColor: "rgba(255,255,255,0.08)" }} id={id}>
      <div>
        {eyebrow && (
          <div className="td-eyebrow mb-2" style={{ color: "#FF8A1F" }}>
            {eyebrow}
          </div>
        )}
        <h2 className="font-display font-extrabold tracking-tight text-2xl md:text-3xl" style={{ color: "#F5F5F2", letterSpacing: "-0.02em" }}>
          {title}
        </h2>
      </div>
      {action}
    </div>
  );
}
